import EditProgram from './components/EditProgram';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';
import values from 'lodash/values';
import { connect } from 'react-redux';

import {
  createProgram,
  updateProgram,
  loadProgramsForAgency
} from '../../shared/redux/entities/actions';

// import { getBrandsWithKPIs } from '../../shared/redux/selectors'
import has from "lodash/has";

function mapStateToProps(state,props){
  const programId = props.match.params.programId,
      agencyId = props.accountId;
  // const brands = getBrandsWithKPIs(state).filter((b) => b.agencyId === props.accountId)
  return {
    agencyId:agencyId,
    programId:programId,
    needsLoading:!has(state,['entities','agencies',agencyId,'name']),
    isCreate:programId === 'new',
    program:get(state,['entities','programs',programId], null),
    giftCards:values(get(state,['entities','giftcards'], {}))
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    createProgram,
    updateProgram,
    loadProgramsForAgency
  },dispatch)
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(EditProgram));



// WEBPACK FOOTER //
// ./src/routes/EditProgram/index.js